// extracted by mini-css-extract-plugin
export var headerCell = "_15-1";
export var loadingStateCell = "_15-4";
export var rowWrapper = "_15-3";
export var standaloneTable = "_15-5";
export var table = "_15-0";
export var white = "_15-2";